import {useAppSelector} from "@Hooks/selector/useAppSelector";

/**
 * Returns full filepath for provided shared image path
 */
export default function useSharedImagesPath(filePath: string): string {
    const assetsBaseUrl = useAppSelector((state) => state?.page.assetsBaseUrl)
    return `${assetsBaseUrl}/apps/shared-images/${window.sharedImagesVersion}/${filePath}`
}